module.exports = __webpack_public_path__ + "img/review.965f01e.webp";